export const BuildInfo = {timestamp:1784331572000}
